import React, { Component } from 'react'
import './ScrollDownArrow.css'

export default class ScrollDownArrow extends Component {
  render() {
    const {onClick} = this.props
    return (
        <div onClick={onClick} className = "arrow animated bounce"></div>
    )
  }
}
